<template>
    <div class="order-status-graphic" v-if="order">
        <div class="status-row">
            <div class="status-icon">
                <order-status-graphic-icon :status="getOrderIconStatus('Order Submitted')"/>
            </div>
            <div class="status-description">{{ orderSubmittedText }}</div>
        </div>
        <div class="status-row">
            <div class="status-icon">
                <order-status-graphic-icon :status="getOrderIconStatus('Order Confirmed')"/>
            </div>
            <div class="status-description">{{ orderConfirmedText }}</div>
        </div>
        <div class="status-row">
            <div class="status-icon">
                <order-status-graphic-icon :status="getOrderIconStatus('Vehicle has arrived in stock')" />
            </div>
            <div class="status-description">{{ arrivedInStockText }}</div>
        </div>
        <div class="status-row">
            <div class="status-icon">
                <order-status-graphic-icon :status="getOrderIconStatus('Delivery Arranged')" />
            </div>
            <div class="status-description">{{ deliveryOrganisedText }}</div>
        </div>
        <div class="status-row">
            <div class="status-icon">
                <order-status-graphic-icon :status="getOrderIconStatus('Implemented')" :is-last="true" />
            </div>
            <div class="status-description">{{ vehicleDeliveredText }}</div>
        </div>
    </div>
</template>

<script>
import PreviouslyCompleted from "./icons/previously-completed";
import LastStep from "./icons/last-step";
import CurrentStatus from "./icons/current-status";
import OrderStatusGraphicIcon from "./order-status-graphic-icon";
import OrderStatus from "@/helpers/order-status";

export default {
    name: "order-status-graphic",
    components: {OrderStatusGraphicIcon, CurrentStatus, LastStep, PreviouslyCompleted},
    props: ['order', 'product'],
    computed: {
        orderStatus() {
            return this.order.orderStatusDescription;
        },
        orderSubmittedText() {
            return this.product?.order_statuses_quote_submitted_heading ? this.product.order_statuses_quote_submitted_heading : '';
        },
        orderConfirmedText() {
            return this.product?.order_statuses_order_confirmed_heading ? this.product.order_statuses_order_confirmed_heading : '';
        },
        arrivedInStockText() {
            return this.product?.order_statuses_arrived_in_stock_heading ? this.product.order_statuses_arrived_in_stock_heading : '';
        },
        deliveryOrganisedText() {
            return this.product?.order_statuses_delivery_organised_heading ? this.product.order_statuses_delivery_organised_heading : '';
        },
        vehicleDeliveredText() {
            return this.product?.order_statuses_vehicle_delivered_heading ? this.product.order_statuses_vehicle_delivered_heading : '';
        },
    },
    methods: {
        getOrderIconStatus(iconStatus) {
            if (this.orderStatus === iconStatus) {
                return 'current';
            }

            return OrderStatus.hasProgressedToStage(iconStatus, this.orderStatus) ? 'completed' : null;
        }
    }
}
</script>

<style scoped lang="scss">
    .order-status-graphic {
        position:relative;
        z-index:1;

        &:before {
            content: "";
            width: 1px;
            display: block;
            height: 87%;
            background: black;
            position: absolute;
            top: 5%;
            left: 38px;
            z-index: 0;
            opacity: 0.1;
        }

        .status-row{
            position: relative;
            z-index: 1;
            display: flex;
            padding: 1rem;
            justify-content: flex-start;
            align-items: center;

            .status-description {
                margin-left: 1.5rem;
            }
        }
    }
</style>
